var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4602 10.1967C17.0404 10.696 17.4629 11.2566 17.4629 12C17.4629 12.7434 17.0404 13.304 16.4602 13.8033C15.8952 14.2895 15.0674 14.8123 14.0403 15.461L13.0282 16.1002C11.8674 16.8334 10.9388 17.4199 10.1853 17.753C9.41984 18.0914 8.6676 18.2448 7.96336 17.8567C7.25911 17.4685 6.98717 16.7506 6.86452 15.9227C6.74379 15.1078 6.7438 14.0095 6.74382 12.6365L6.74382 11.3635C6.7438 9.99051 6.74379 8.89222 6.86452 8.07729C6.98717 7.24941 7.25912 6.53145 7.96336 6.14329C8.6676 5.75514 9.41984 5.90859 10.1853 6.24698C10.9388 6.58007 11.8674 7.16657 13.0282 7.89972L14.0403 8.53898C15.0674 9.18766 15.8952 9.71047 16.4602 10.1967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.47db03d3a824798643186c51b241c6ce.svg";
export { ForwardRef as ReactComponent };